const svgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="art-preview__room-delete">
  <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
  <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
</svg>`

console.log(window.customerId)

$(document).ready(function() {
  // creating the room preview images array
  const metafields = [
    'room_image_1',
    'room_image_2',
    'room_image_3',
    'room_image_4'
  ]
  let availableMetafields = [];
  let roomPreviewImages = [];

  // creating the art preview canvas
  // if fabric is not defined, skip this
  (function() {
    if (typeof fabric === 'undefined') {
      return;
    }
    var canvas = this.__canvas = new fabric.Canvas('room-preview');
    let cornerColor = `rgba(${window.customizerButtonColor}, .8)`;
    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.cornerStyle = 'circle';
    fabric.Object.prototype.cornerColor = cornerColor;
    
    // set the background image on the canvas
    changeCanvasBackground(window.defaultRoomImage);

    // render the art object on the canvas
    const artPreviewImage = window.artImage;
    fabric.Image.fromURL(artPreviewImage, function(img) {
      // img._element.crossOrigin = 'anonymous';
      canvas.add(img.set({ left: canvas.width/2.5, top: canvas.height/4 }).scale(0.15));

      //set as active object
      canvas.setActiveObject(img);

      // on click of the document body, deselect the canvas object
      $(document).click(function(e) {
        // if target class is not a child of .canvas-container
        if ($(e.target).closest('.canvas-container').length === 0) {
          canvas.discardActiveObject();
          canvas.renderAll();
        }
      });

      // downloading the canvas as an image
      $('#submit-art-preview').click(async function(e) {
        e.preventDefault();
        canvas.discardActiveObject();
        canvas.renderAll();
        const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
        $('#submit-room').fadeIn(300);

        // when clicking the .confirm button with the grandparent of #submit-room, submit the form with the class .art-preview__form
        $('#submit-room').on('click', '.confirm', async function(e) {
          e.preventDefault();
          // add a loader to the button
          $('.art-preview__button.confirm').append('<img class="art-preview__button-loader" src="https://cdn.shopify.com/s/files/1/0636/2218/5200/files/Rolling-1s-200px.gif?v=1690238354" width="24px" />');

          // upload the room image to the server
          const data = await uploadRoomImage(image,'not-shopify');
          const $form = $('.art-preview__form');
          const $inputs = $form.find('input');
        
          // clear previous error messages
          $('.art-preview__form-error').text('');

          let isValid = true;
        
          $inputs.each(function() {
            // check each input's validity
            if (!this.checkValidity()) {
              // display the error message for the invalid input
              let errorMessage = this.validationMessage;
      
              // add an error message element after the last element of the input's parent
              $(this).siblings('.art-preview__form-error').text(errorMessage);
            }
            $('.art-preview__button-loader').remove();
          });

          const email = $('#email').val();
          if(!validateEmail(email)) {
            $('#email').siblings('.art-preview__form-error').text('Please enter a valid email address.');
            isValid = false;
            $('.art-preview__button-loader').remove();
          }

          const phone = $('#phone').val();
          if(!validatePhone(phone)) {
            $('#phone').siblings('.art-preview__form-error').text('Please enter a valid phone number.');
            isValid = false;
            $('.art-preview__button-loader').remove();
          }

          if (isValid) {
            // if form is valid, submit the form
            $('#room-design').val(data);
            $('#submit-room').fadeOut(300);
            $form[0].submit();
          }
        });
      });
    },{ crossOrigin: 'anonymous'});
  })();

  // loading user's room images, if user is logged in
  if (window.customerId) {
    loadRoomImages();
  }

  // selecting a room image from the gallery
  $('.art-preview__room-gallery').on('click', '.art-preview__room-image', function(e) {
    e.preventDefault();
    // get the image url
    const imageURL = $(this).attr('src');
    // change the background of the canvas
    changeCanvasBackground(imageURL);
  });

  // uploading new room image
  $('#image-uploader-label').click(function(e) {
    // check if user is logged in and if they have uploaded 4 images already
    if (window.customerId && roomPreviewImages.length >= 4) {
      e.preventDefault();
      $('#max-rooms').fadeIn(300);
    }
  });
  $('#image-uploader').change( async e => {
    if (typeof fabric !== 'undefined') fadeInLoadingOverlay();
    try {
      const data = await uploadRoomImage(e,`${window.customerId ? 'shopify' : 'not-shopify'}`);
      let imageURL = ""
      let imageMetafieldId = ""
      if (window.customerId !== '') {
        imageURL = data.metafield.value;
        imageMetafieldId = data.metafield.id;
        if (typeof fabric !== 'undefined') changeCanvasBackground(imageURL)
        generateRoomThumbnail(imageURL, imageMetafieldId);
        roomPreviewImages.push(data.metafield);
        availableMetafields.shift();
        console.log('availableMetafields: ', availableMetafields)
        console.log('roomPreviewImages: ', roomPreviewImages)
      } else {
        imageURL = data
        changeCanvasBackground(imageURL)
      }
      fadeOutLoadingOverlay();
    } catch (error) {
      console.log(error)
    }
  });

  // deleting a room image
  $('.art-preview__room-gallery').on('click', '.art-preview__room-delete', function(e) {
    e.preventDefault();
    const imageURL = $(this).siblings('img').attr('src');
    const imageId = imageURL.split('/').pop().split('.')[0];

    // fade in the modal
    $('#delete-room').fadeIn(300);
    const imageMetafieldId = $(this).parent().data('metafield-id');
      // on clicking the .close-modal button with the grandparent of #delete-room
    $('#delete-room').on('click', '.confirm', function(e) {
      e.preventDefault();
      if (typeof fabric !== 'undefined') changeCanvasBackground('https://cdn.shopify.com/s/files/1/0636/2218/5200/files/art-preview-default-room.jpg?v=1693068867');
      deleteRoomImage(imageMetafieldId, imageId);
      $('#delete-room').fadeOut(300);
    });
  });

  // close modal
  $('.close-modal').click(function(e) {
    e.preventDefault();
    // fade out the parent or grandparent of the close button with the class art-preview__modal
    $(this).closest('.art-preview__modal').fadeOut(300);
  });

  // if the url parameter 'contact-posted' = true, show the #submission-confirmation modal
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('contact_posted') === 'true') {
    $('#submission-confirmation').fadeIn(300);
  }

  // show the art preview
  $('#show-art-preview').click(function(e) {
    e.preventDefault();
    $(this).fadeOut(300);
    $('.canvas-container').delay(300).fadeIn(300);
    $('#image-uploader-label').css('display', 'flex').hide().delay(200).fadeIn(300);
    $('#submit-art-preview').delay(300).fadeIn(300);
  });

  // close the art preview
  $('#close-art-preview').click(function(e) {
    e.preventDefault();
    $('.canvas-container').fadeOut(300);
    $('#image-uploader-label').fadeOut(300);
    $('#submit-art-preview').fadeOut(300);
    $('#show-art-preview').delay(300).fadeIn(300);
  });

  function changeCanvasBackground(imageURL, canvas = this.__canvas) {
    const artPreviewContainer = $('.art-preview')
    
    if (typeof imageURL === 'undefined') {
      // .art-preview__loading-overlay should be hidden
      $('.art-preview__loading-overlay').hide();
      return;
    }

    fabric.Image.fromURL(`${imageURL}`, function(img) {
      canvas.setDimensions({width: artPreviewContainer.width(), height: artPreviewContainer.height()});
      const ratio = canvas.width / img.width;
      canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
        scaleX: ratio,
        scaleY: ratio
      });
      // resize canvas height to match background image height
      canvas.setDimensions({width: artPreviewContainer.width(), height: img.height * ratio});
    },{ crossOrigin: 'anonymous'});
  }

  function fadeInLoadingOverlay() {
    // toggle visibility of the loading overlay
    $('.art-preview__loading-overlay').height($(".canvas-container").height());
    // center the .art-preview__loading-gif
    $('.art-preview__loading-gif').css('top', `${$(".canvas-container").height()/2 - $('.art-preview__loading-gif').children('svg').height()/2}px`);
    $('.art-preview__loading-gif').css('left', `${$(".canvas-container").width()/2 - $('.art-preview__loading-gif').children('svg').width()/2}px`);
    $('.art-preview__loading-overlay').fadeIn(300);
  }

  function fadeOutLoadingOverlay() {
    $('.art-preview__loading-overlay').fadeOut(1000);
  }

  function loadRoomImages() {
    $.ajax({
      url: 'https://hh-art-preview.cyclic.app/images',
      type: 'GET',
      data: {customerId: window.customerId},
      success: function(data) {
        console.log(data)
        // filter data.metafields to metafields with keys that contain the word 'room_image'
        data.metafields.forEach(metafield => {
          if (metafield.key.includes('room_image') && metafield.value !== '') {
            roomPreviewImages.push(metafield);
          }
        })
        console.log('roomPreviewImages: ', roomPreviewImages)
        roomPreviewImages.forEach(room => generateRoomThumbnail(room.value, room.id))
        // find available fields by filtering metafields array for metafields that are not a value of key for each object in roomPreviewImages
        availableMetafields = metafields.filter(metafield => {
          return !roomPreviewImages.some(room => room.key === metafield)
        })
        console.log('availableMetafields: ', availableMetafields)
      },
      error: function(error) {
        console.log(error)
      }
    });
  }

  function generateRoomThumbnail(imageURL, imageMetafieldId) {
     // if customer is logged in, add the image to the roomPreviewImages array
    if (window.customerId) {
      $('.art-preview__room-gallery').append(`<div class="art-preview__room-thumbnail" data-metafield-id="${imageMetafieldId}"><img src="${imageURL}" class="art-preview__room-image"/>${svgString}</div>`)
    }
  }

  async function uploadRoomImage(input, uploadType = 'not-shopify') {
    console.log(input)
    console.log(typeof input)
    const maxSize = 5 * 1024 * 1024; // 5MB
    // create a FormData object and append the image file to it
    const formData = new FormData();
  
    // check if input is an event object
    if (typeof input === 'object' && input.target.files[0]) {
      // get the selected image file from the event target
      const imageFile = input.target.files[0];
      if (imageFile && imageFile.size > maxSize) {
        $('#max-size').fadeIn(300);
        return;
      }
      // append the image file to the FormData object
      formData.append('file', imageFile);
    } else if (typeof input === 'string') {
      // convert the dataURL to a Blob object
      const blob = await (await fetch(input)).blob();
      // create a File object from the Blob
      const imageFile = new File([blob], 'image.png');
      if (imageFile && imageFile.size > maxSize) {
        $('#max-size').fadeIn(300);
        return;
      }
      // append the image file to the FormData object
      formData.append('file', imageFile);
    } else {
      throw new Error('Invalid input type');
    }
  
    // pass in the customer id
    formData.append('customerId', window.customerId);
    // pass in the number of room images the customer has uploaded
    formData.append('metafield', availableMetafields[0]);
    // pass in uploadTypes
    formData.append('uploadType', uploadType);
  
    // send the image file to middleware
    const response = await fetch('https://hh-art-preview.cyclic.app/upload', {
      method: 'POST',
      body: formData
    });
  
    const data = await response.json();

    return data;
  }
  

  function deleteRoomImage(imageMetafieldId, imageId) {
    // delete the image from the roomPreviewImages array
    roomPreviewImages = roomPreviewImages.filter(room => room.id !== imageMetafieldId);
    console.log('roomPreviewImages: ', roomPreviewImages)
    // delete the image from the DOM
    $(`.art-preview__room-thumbnail[data-metafield-id="${imageMetafieldId}"]`).remove();
    // delete the image from the Shopify metafields using 
    $.ajax({
      url: `https://hh-art-preview.cyclic.app/images?customerId=${window.customerId}&metafieldId=${imageMetafieldId}&imageId=${imageId}`,
      type: 'DELETE',
      success: function(data) {
        console.log(data)
      },
      error: function(error) {
        console.log(error)
      }
    });
    // update the availableMetafields array
    availableMetafields = metafields.filter(metafield => {
      return !roomPreviewImages.some(room => room.key === metafield)
    })
    console.log('availableMetafields: ', availableMetafields)
  }

  function validateEmail(email) {
    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return pattern.test(email);
  }

  function validatePhone(phone) {
    const pattern = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;
    return pattern.test(phone);
  }

});
